import React, { useState } from "react";
import { Modal, Input, Button, notification } from "antd";

export const FamilyEnableAccountBtn = ({ sexOffender, enableAccount }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    await enableAccount(reason);
    setLoading(false);
  };

  const onOpen = () => {
    if (sexOffender) {
      notification.error({
        message: `Cannot enable account for the sex offender user.`,
      });
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <Button onClick={onOpen} size="small" danger>
        Enable Account
      </Button>
      <Modal
        title="Enable Account Reason"
        visible={open}
        centered
        onOk={save}
        confirmLoading={loading}
        onCancel={() => setOpen(false)}
        maskClosable={false}
        okButtonProps={{ disabled: !reason.trim() }}
      >
        <Input.TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={250}
          placeholder="Enter reason for enabling account"
        />
      </Modal>
    </>
  );
};
